module.exports = __webpack_public_path__ + "static/media/join-us-viber-icon.a2a8d075.png";